module.exports = __webpack_public_path__ + "img/image_4.93bb937a.png";